<template>
  <div>
    <v-row class="" align="center" align-content-sm="left">
      <v-col cols="12" md="3">
        <h3 align="start">Evaluations List</h3>
      </v-col>
     
      <v-spacer></v-spacer>
       <v-col cols="12" md="6">
      <v-text-field
        v-model="search"
        v-if="currentUser.privileges.canEvaluateAdmissions"
        append-icon="mdi-magnify"
        label="Search evaluations"
        single-line
        hide-details
        align-self="center"
        class="my-2 mx-5"
      ></v-text-field>
      
       </v-col>

       <v-col cols="12" md="2">
         <download-excel
          v-if="currentUser.privileges.canExportEvaluations"
          :fetch="getExportData"
          :fields="export_fields"
          :name="getExportName"
        >
          <v-btn
            class="ml-3 text-right"
            :loading="export_in_progress"
            :disabled="export_in_progress"
            color="white"
            elevation="1"
          >
            Export
            <v-icon right dark> mdi-export </v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </download-excel>
      </v-col>
       <!-- <v-col cols="12" md="3" align-self="center">
      <div class="text-right">
        <v-btn rounded color="primary">
          <v-icon>mdi-account-plus</v-icon>
          Add Evaluation
        </v-btn>
      </div>
      </v-col> -->
    </v-row>
    <!-- <v-data-table fixed-header height="500px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="headers">
              Enquiry No.
            </th>
            <th class="headers">
              Date
            </th>
            <th class="headers">
              Name
            </th>
            <th class="headers">
              Phone No.
            </th>
            <th class="headers">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in enquiries" :key="item.enquiryNumber">
            <td class="data">{{ item.enquiryNumber }}</td>
            <td class="data">{{ item.enquiryDate }}</td>
            <td class="data">{{ item.name }}</td>
            <td class="data">{{ item.phoneNumber }}</td>
            <td class="data">{{ item.status }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table> -->

    <v-data-table
      :headers="headers"
      :items="evaluations"
      v-if="currentUser.privileges.canEvaluateAdmissions"

      :multi-sort="false"
      :options.sync="options"
      v-model="selected"
      :items-per-page="15"
    >
      <template v-slot:item.admission_unique_id="{ item }">
        <router-link
          :to="{name: 'EditAdmissionDetails', params: {admission_id: item.id}}"
        >
          <span>{{ item.admission_unique_id || "-" }}</span>
        </router-link>
      </template> 
      <template v-slot:item.is_terminated="{ item }">
        <v-chip :color="item.is_terminated? 'red' : 'primary'" outlined v-if="!item.is_terminated">
          <h5>{{ item.is_terminated ? "Terminated" : "In Process"}}</h5>
        </v-chip>
      </template>
      <template v-slot:item.created_at="{item}">
        {{ moment(item.created_at).format("D MMM, YYYY") }}
      </template>
      <template v-slot:item.full_name="{item}">
        {{ item.basic_info.candidate_first_name }} {{ item.basic_info.candidate_last_name }}
      </template>
    </v-data-table>
    <div v-else><h3>You do not have sufficient privileges.</h3></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import moment from "moment";
import Helper from "@utils/misc";
import JsonExcel from "vue-json-excel";


export default {
  name: "EvaluationsList",
 
  data() {
    return {
      pagination: {
        totalCount: 0,
        url: endpoints.admissions + "?status=4&is_terminated=False",
      },
      export_url : endpoints.admissions + "?status=4&is_terminated=False&export=true",
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "Evaluation no.",
          align: "left",
          sortable: true,
          value: "admission_unique_id"
        },
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "created_at"
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "full_name"
        },
        {
          text: "Documents",
          align: "left",
          sortable: false,
          value: "basic_info.uploaded_documents_count"
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "is_terminated"
        }
      ],
      evaluations: [],
      snackbar: {
        visible: false,
        text: "",
      },
      options:{},
      export_in_progress: false,
      export_fields: {
        "ID": "admission_unique_id",
        "Date" : {
          field: "all_dates",
          callback: (list) => {
            return moment((list.find((x) => x.status == 4 )).created_at).format("D MMM, YYYY");
          }
        },
        "Name": "application_details.full_name",
        "Mobile": "application_details.mobileno",
        "Alternate No." : "application_details.alternate_mobileno",
        "Email": "application_details.email",
        "Gender":{
          field: "application_details.gender",
          callback: (value) => {
            var gender_mapping = {
              "M" : "Male",
              "F" : "Female",
              "O" : "Other"
            }
            return gender_mapping[value];
          }
        },
        "Class Standard" : "application_details.class_standard.display",
        "DOB" : "application_details.date_of_birth",
        "Place of Birth" : "application_details.place_of_birth",
        "Nationality" : "application_details.nationality",
        "Aadhar" : {
          field: "application_details.aadhaar_card_number",
          callback: (value) => {
            return String(value);
          }
        },
        "Mother Tongue" : "application_details.mother_tongue",
        "Religion" : "application_details.religion",
        "Caste" : "application_details.caste",
        "Address" : "application_details.address",
        "District" : "application_details.district",
        "State" : "application_details.state",
        "Pincode" : "application_details.pincode",
        "Status": "current_status",
        "Previous School" : "application_details.previous_school_name",
        "Previous Standard" : "application_details.previous_school_name",
        "Previous Percentage" : "application_details.previous_standard_percentage",
        "Confirmation Unlocked": {
          field: "unlock_for_next",
          callback: (value) => {
            return value ? 'Yes' : 'No'
          }
        },
        "No of documents" : "admission_docs.length",
      },
    };
  },
  components: {
    downloadExcel: JsonExcel,
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
    getExportName() {
      return Helper.getExportName();
    },
  },
  methods:{
    ...mapActions(["setLoading"]),
    moment: moment,
    
    async getAllEvaluations(){
      var response;
      var url = this.pagination.url;
      if(this.search){
        url += (url.split("?")[1] ? "&" : "?") + "q=" + this.search;
      }
      response = await api.call(this.apiEssentials, url);
      if(response){
        this.evaluations = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      } 
    },

    async getExportData() {
      this.export_in_progress = true;
      var response;
      // var url = endpoints.admissions + "?status=4&is_terminated=False&extract=true";

      if (this.search) {
        this.export_url += "q=" + this.search;
      }

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: this.export_url,
        responseVar: response,
      });

      if (response) {
        this.export_in_progress = false;
        return response;
      }
    },

    enquiry_status_color(item){
      return item.is_terminated ? 'red' : 'primary'; 
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
  },
  watch:{
    options: {
      async handler() {
        this.pagination.url =
          endpoints.admissions + "?status=4&is_terminated=False&page=" + this.options.page;
          if (this.options.sortBy.length > 0) {
          // get url var
          var params = "&order_by=";
          
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }

          if(params.includes('full_name')){
            params = params.replace('full_name','application_details__candidate_first_name')
          }
          if (params.includes("created_at")) {
            params = params.replace("created_at", "updated_on");
          }
          if (params.includes("current_status")) {
            params = params.replace("current_status", "unlock_for_next");
          }

          this.pagination.url += params;
          this.export_url += params;
        }
        if(this.currentUser.privileges.canEvaluateAdmissions) this.getAllEvaluations();
      },
    },
    search: {
      async handler() {
          this.options.page = 1;
          var searched = this.search;
          var self = this;
          setTimeout(function () {
              if (searched == self.search) {
                 if(self.currentUser.privileges.canEvaluateAdmissions) self.getAllEvaluations();
              }
          }, 500);
      },
    }
  },
  created(){
    // if(currentUser.privileges.canEvaluateAdmissions) this.getAllEvaluations(); <- already called in watch options
  }
};
</script>


<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;
  color: #0c090a;
  vertical-align: middle;
}
</style>
